export default __webpack_public_path__ + "static/media/low_priority_banner.30140385.svg";